// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__32Lqf","errors":"Errors_errors__1h1Vy"};